export const config = {
    LINK : {
        BASE_URL_UPLOADFILE: process.env.REACT_APP_LINK_UPLOADFILE,
        B4E: process.env.REACT_APP_LINK_B4E,
        PRODUCTION_ANALYTICS: process.env.REACT_APP_LINK_PRODUCTION_ANALYTICS,
        DRILLING_OPTIMIZATION: process.env.REACT_APP_LINK_DRILLING_OPTIMIZATION,
    },
    API: {
        BASE_URL_ACCESS_CONTROL : process.env.REACT_APP_PORT_DB,
        BASE_URL_FILTER : "/api/extdata",
        BASE_URL_TABLES: "/api/outputdata",
        BASE_URL_WELL : "/api/extdata",
        BASE_RUN_WELL : "/api/run",
        BASE_URL_STREAM : "/api/streaming",
        BASE_URL_STREAM_TABLES : "/api/streaming",
        BASE_URL_STREAM_DATA : "/api/streaming",
        BASE_URL_STREAM_DEPTH : "/api/streaming",
        BASE_URL_RUN_API : "/api/run",
        BASE_URL_SCENARIO : "/api/scenarios",
        BASE_URL_CACHE: "/api/cache",
        BASE_URL_SOCKET: process.env.REACT_APP_BASE_URL_SOCKETS,
        BASE_URL_BUILD_UP_RATE: "/api/bur",
        BASE_URL_PARAMETERS: "/api/parameters",
        BASE_URL_STREAMING_ADMIN: "/api/streams-admin"
    },
}

export const keyIntegration = {
    keyEncrypt : process.env.REACT_APP_KEYENCRYPT,
}

// Backend API keys are added server-side by the nginx proxy in this container
// (nginx/default.conf.template), which first checks the user's session token
// with access control. The browser only sends that token.
export const apiAuthHeaders = () => ({
    "x-access-token": JSON.parse(sessionStorage.getItem("userData") || "{}")?.token ?? "",
})
